// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"80b23998","68":"1b6871e0","137":"f31ac7ed","159":"9c601c26","253":"3e30a15e","315":"b92f0cae","358":"504c9358","392":"0ec11061","396":"ebb9d3fc","540":"e20954d9","585":"1ea9f891","696":"6b38011e","715":"31add4cd","761":"c7c3545d","767":"5efbe651","843":"bb578581"}[chunkId] + ".chunk.js";
};